import React from 'react';

export const orderReturnAssignConfig = [
  {
    path: '/assign-pic',
    component: React.lazy(() => import('./listing/listing')),
  },

  {
    path: '/assign-pic/rincian-order-cash-return-assign',
    component: React.lazy(() =>
      import('./rincianOrderAssign/rincianOrderAssign'),
    ),
  },
];
